import AddressFormatter from "@shopify/address";
import { useQuery } from "@tanstack/react-query";

export const useCountriesQuery = ({ locale }: { locale: string }) => {
  const data = useQuery({
    queryKey: ["countries", locale],
    queryFn: async () => {
      const addressFormatter = new AddressFormatter(locale);
      return await addressFormatter.getCountries();
    },
  });

  return data;
};
